import { render, staticRenderFns } from "./AdminGeneralGroup.vue?vue&type=template&id=4104d994&"
import script from "./AdminGeneralGroup.vue?vue&type=script&lang=js&"
export * from "./AdminGeneralGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports